import React, { useLayoutEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

type Props = {
	clientX: number;
	clientY: number;
	className?: string;
	children: React.ReactNode;
};

const OFFSET_X = 12;
const OFFSET_Y = 10;
const EDGE_MARGIN = 8;

const ChartTooltipPortal = ({ clientX, clientY, className, children }: Props) => {
	const ref = useRef<HTMLDivElement>(null);
	const [size, setSize] = useState<{ w: number; h: number } | null>(null);

	useLayoutEffect(() => {
		if (ref.current) {
			const rect = ref.current.getBoundingClientRect();
			setSize({ w: rect.width, h: rect.height });
		}
	}, [children]);

	let style: React.CSSProperties;
	if (!size) {
		style = { left: 0, top: 0, visibility: 'hidden' };
	} else {
		const viewportW = window.innerWidth;
		const viewportH = window.innerHeight;
		const wantsRight = clientX + OFFSET_X;
		const flipX = wantsRight + size.w > viewportW - EDGE_MARGIN;
		const left = flipX ? Math.max(EDGE_MARGIN, clientX - OFFSET_X - size.w) : wantsRight;
		let top = clientY - OFFSET_Y;
		if (top + size.h > viewportH - EDGE_MARGIN) top = viewportH - EDGE_MARGIN - size.h;
		if (top < EDGE_MARGIN) top = EDGE_MARGIN;
		style = { left, top };
	}

	return ReactDOM.createPortal(
		<div ref={ref} className={className} style={style}>
			{children}
		</div>,
		document.body,
	);
};

export default ChartTooltipPortal;
